// extracted by mini-css-extract-plugin
module.exports = {"player-hand":"player-hand_player-hand__rz_5C","grid":"player-hand_grid__UR2P0","drag-slot":"player-hand_drag-slot__glLms","hand-slot":"player-hand_hand-slot__Rcytu"};